export const MenuItems = [
  {
    title: "Baby Zepps",
    path: "/teams/baby-zepps",
    cName: "dropdown-link",
  },
  {
    title: "Bad Dog",
    path: "/teams/bad-dog",
    cName: "dropdown-link",
  },
  {
    title: "Beauties",
    path: "/teams/beauties",
    cName: "dropdown-link",
  },
  {
    title: "Beavis & Buntheads",
    path: "/teams/beavis-and-buntheads",
    cName: "dropdown-link",
  },
  {
    title: "Comedy Bar",
    path: "/teams/comedy-bar",
    cName: "dropdown-link",
  },
  {
    title: "Hecklers",
    path: "/teams/hecklers",
    cName: "dropdown-link",
  },
  {
    title: "Jokebox",
    path: "/teams/jokebox",
    cName: "dropdown-link",
  },
  {
    title: "Orphans",
    path: "/teams/orphans",
    cName: "dropdown-link",
  },
  {
    title: "Pring's Things",
    path: "/teams/pringsthings",
    cName: "dropdown-link",
  },
  {
    title: "Slo Claps",
    path: "/teams/sloclaps",
    cName: "dropdown-link",
  },
];
